import { useCallback } from "react";
import { CollectionVideoResponse } from "@switcherstudio/player-api-client";
import useCollectionWithVideos from "./useCollectionWithVideos";

export const useGetVideoByPlaylistBroadcastId = () => {
    const { allVideos } = useCollectionWithVideos();

    const getVideoFromPlaylistBroadcasts = useCallback(
        (
            playlistBroadcastId: string | undefined
        ): CollectionVideoResponse | undefined => {
            if (!playlistBroadcastId) return;

            const defaultPlaylistBroadcasts = allVideos ?? [];
            const currentVideoFromPlaylist = defaultPlaylistBroadcasts.find(
                (video) => video?.details?.id === playlistBroadcastId
            );

            return currentVideoFromPlaylist;
        },
        [allVideos]
    );

    return {
        getVideoFromPlaylistBroadcasts
    };
};
